<template>
  <div class="homework_list">
    <!-- <div class="top_box mar_top_20 flex Flexjustify flexcolumn">
      <div class="filter_box flex">
        <div>时间:</div>
        <div class="flex FlexWrap flex-1">
          <div
            v-for="(item, index) in timeRangeList"
            :key="index"
            class="area_info cursor_pointer"
            :class="[
              selectedInfo.timeRange == item.value ? 'active_area_info' : '',
            ]"
            @click="selectStage(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>学科:</div>
        <div class="flex FlexWrap flex-1">
          <div
            class="area_info cursor_pointer"
            :class="[selectedInfo.subjectId == '' ? 'active_area_info' : '']"
            @click="selectSubjet('')"
          >
            不限
          </div>
          <div
            v-for="(item, index) in subjectList"
            :key="index"
            class="area_info cursor_pointer"
            :class="[
              selectedInfo.subjectId == item.subjectId
                ? 'active_area_info'
                : '',
            ]"
            @click="selectSubjet(item.subjectId)"
          >
            {{ item.subjectName }}
          </div>
        </div>
      </div>
    </div>
    <div class="list_box">
      <div class="flex menu_list mt-20">
        <div
          class="menu_one mr-30"
          v-for="(item, index) in menuList"
          :key="index"
          :class="item.value == selectedMenu ? 'menu_one_active' : ''"
          @click="changeMenu(item)"
        >
          <div>
            {{ item.label }} <span class="menu_num">({{ item.num }})</span>
          </div>
          <div class="menu_line" v-show="item.value == selectedMenu"></div>
        </div>
      </div>
    </div>
    <div
      class="wrong_one my-20"
      v-for="(item, index) in homeworkList"
      :key="index"
    >
      <div class="wrong_one_top flex Flexalign FlexBetween">
        <div class="flex Flexalign">
          <el-image
            class="select_play cursor_pointer"
            :src="imgPath('select_play.png')"
            v-if="item.isExpend"
            @click="changeIsExpend(item)"
          ></el-image>
          <el-image
            class="select_play selected_play cursor_pointer"
            :src="imgPath('select_play.png')"
            v-else
            @click="changeIsExpend(item)"
          ></el-image>
          <div class="mar_left_15">
            <span>课程名称：</span>
            <span class="text_active">《{{ item.courseName }}》</span>
          </div>
        </div>
        <div class="text_active">{{ item.subHomeworkList.length }}个</div>
      </div>
      <div class="sub_homework_list" v-if="item.isExpend">
        <div
          class="sub_homework_one flex FlexBetween Flexalign p-20 mb-20"
          v-for="(sitem, sindex) in item.subHomeworkList"
          :key="sindex"
        >
          <div class="sub_homework_one_left flex Flexalign">
            <el-image
              class="homework_list_icon"
              :src="iconPath('homework_list_icon.png')"
            ></el-image>
            <div
              class="flex flexcolumn FlexBetween ml-15 FlexStart homework_info"
            >
              <div class="homework_name">{{ sitem.name }}</div>
              <div class="">{{ sitem.desc }}</div>
              <div class="flex Flexalign">
                <div v-if="sitem.type == 1">
                  试题数量：{{ sitem.countNum }}题
                </div>
                <div class="split_line mx-15" v-if="sitem.type == 1"></div>
                <div v-if="sitem.type == 1">
                  总分值：{{ sitem.fullScore }}分
                </div>
                <div class="split_line mx-15" v-if="sitem.type == 1"></div>
                <div v-if="sitem.type == 2">总评分：{{ sitem.fullScore }}</div>
                <div class="split_line mx-15" v-if="sitem.type == 2"></div>
                <div v-if="sitem.type == 4">
                  总分值：{{ sitem.fullScore }}分
                </div>
                <div class="split_line mx-15" v-if="sitem.type == 4"></div>
                <div v-if="sitem.type == 3">关卡数：{{ sitem.countNum }}关</div>
                <div class="split_line mx-15" v-if="sitem.type == 3"></div>
                <div v-if="sitem.type == 3">
                  闯关模式：{{ sitem.fullScore }}
                </div>
                <div class="split_line mx-15" v-if="sitem.type == 3"></div>
                <div>提交时间：{{ sitem.submitTime }}</div>
              </div>
            </div>
          </div>

          <div class="sub_homework_one_right">
            <div class="flex FlexBaseline" v-if="sitem.type == 1">
              <span class="homework_score">{{ sitem.score }}</span>
              <span class="homework_score_unit">分</span>
            </div>
            <div class="homework_level" v-if="sitem.type == 2">
              {{ sitem.score }}
            </div>
            <div class="homework_btn" v-if="sitem.type == 4">
              待批阅
            </div>
            <div class="homework_level" v-if="sitem.type == 3">
                <el-image
              class="free_course_buy_success"
              :src="iconPath('free_course_buy_success.png')"
            ></el-image>
              <div class="text_active mt-5 ">闯关成功</div>
            </div>
            <el-image
              class="homework_score_icon"
              :src="iconPath('homework_score_icon.png')"
              v-if="sitem.type == 1"
            ></el-image>
          </div>
        </div>
      </div>
    </div> -->
    <moe-empty url="development_icon_gray.png" emptyText="功能开发中，敬请期待"></moe-empty>
  </div>
</template>

<script>
export default {
  name: "GjkcH5HomeworkList",

  data() {
    return {
      timeRangeList: [
        { label: "今日", value: 1 },
        { label: "本周", value: 2 },
        { label: "本月", value: 3 },
      ],
      selectedInfo: {
        timeRange: 1,
        subjectId: "",
      },
      subjectList: [],
      menuList: [
        { label: "待完成", value: 1, num: 20 },
        { label: "已完成", value: 2, num: 20 },
      ],
      selectedMenu: 1,
      homeworkList: [
        {
          courseName: "课程名称课程名称",
          isExpend: false,
          subHomeworkList: [
            {
              name: "6月10日 《三角函数》导入阶段 课堂作",
              desc: "将整个视频中所讲述的知识点融入在测试卷里",
              countNum: 40,
              fullScore: 100,
              type: 1, // type为1、按分数，2、按评分等级，3、闯关，4、自定义
              submitTime: "08-28 13:45",
              status: 1,
              score: 10,
            },
            {
              name: "6月10日 《三角函数》导入阶段 课堂作",
              desc: "需要讲本次课程中讲解的文言文，背诵下来排",
              fullScore: "五星",
              type: 2, // type为1、按分数，2、按评分等级，3、闯关，4、自定义
              submitTime: "08-28 13:45",
              status: 1,
              score: "A+",
            },
            {
              name: "6月10日 《三角函数》导入阶段 课堂作",
              desc: "需要讲本次课程中讲解的文言文，背诵下来排",
              countNum: 5,
              fullScore: "普通模式",
              type: 3, // type为1、按分数，2、按评分等级，3、闯关，4、自定义
              submitTime: "08-28 13:45",
              status: 1,
              score: "A+",
            },
            {
              name: "6月10日 《三角函数》导入阶段 课堂作",
              desc: "将整个视频中所讲述的知识点融入在测试卷里",
              fullScore: 100,
              type: 4, // type为1、按分数，2、按评分等级，3、闯关，4、自定义
              submitTime: "08-28 13:45",
              status: 1,
              score: 10,
            },
          ],
        },
      ],
    };
  },

  mounted() {
    this.subjectList = this.$store.state.filter.subjectList;
  },

  methods: {
    changeMenu(info) {
      this.selectedMenu = info.value;
    },
    changeIsExpend(info) {
      info.isExpend = !info.isExpend;
    },
  },
};
</script>

<style lang="scss" scoped>
.homework_list {
  .top_box {
    width: 100%;
    box-sizing: border-box;
    background: #f5f6f8;
    border-radius: 10px;
    padding: 15px;

    .filter_box {
      //   width: $pageMainWidth;
      line-height: 32px;

      // margin-bottom: 10px;
      .area_info {
        padding: 0 11px;
        box-sizing: border-box;
        margin-left: 10px;
      }

      .active_area_info {
        color: #13d6aa;
      }

      .filter {
        width: 95px;
        height: 32px;
        border-radius: 5px;
        border: 1px solid #e1e1e1;
        line-height: 32px;

        .filter_icon {
          width: 18px;
          height: 18px;
        }
      }
    }
  }

  .list_box {
    .menu_one {
      position: relative;
      font-size: 18px;
      color: #999999;

      .menu_line {
        position: absolute;
        width: 20px;
        height: 3px;
        background: #13d6aa;
        border-radius: 2px;
        left: calc(50% - 10px);
        top: 30px;
      }

      .menu_num {
        color: #13d6aa;
      }
    }

    .menu_one_active {
      color: #333333;
    }
  }

  .wrong_one {
    .wrong_one_top {
      color: #666666;
      padding-bottom: 20px;
      //   border-bottom: 1px solid rgba(20, 20, 20, 0.1);

      .select_play {
        width: 24px;
        height: 24px;
        transition: 0.5s;
        rotate: -90deg;
      }

      .selected_play {
        rotate: 90deg;
      }
    }
    .sub_homework_list {
      .sub_homework_one {
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        .sub_homework_one_left {
          font-size: 12px;
          color: #999999;
          .homework_list_icon {
            width: 80px;
            height: 80px;
          }
          .homework_info {
            height: 80px;
            .homework_name {
              font-size: 14px;
              color: #111111;
            }
            .split_line {
              width: 1px;
              height: 13px;
              background: rgba(0, 0, 0, 0.1);
            }
          }
        }
        .sub_homework_one_right {
            min-width: 67px;
            text-align: center;
          .homework_score {
            font-weight: 500;
            font-size: 32px;
            color: #fd673b;
          }
          .homework_score_unit {
            font-size: 14px;
            color: #fd673b;
          }
          .homework_score_icon {
            width: 67px;
            height: 26px;
          }

          .homework_level {
            font-size: 34px;
            color: #f1a42f;
          }
          .homework_btn{
            width: 61px;
height: 27px;
background: linear-gradient( 97deg, #FFB95C 0%, #FFDB4A 100%);
border-radius: 14px;
text-align: center;
line-height: 27px;
font-size: 12px;
color: #FFFFFF;
          }
          .free_course_buy_success{
            width: 44px;
            height: 44px;
          }
        }
      }
    }
  }
}
</style>